export const supportsFieldSizingContent: boolean =
  typeof CSS !== 'undefined' &&
  typeof CSS.supports === 'function' &&
  CSS.supports('field-sizing', 'content')

const BASE_ROW_HEIGHT = 25

export function autoResizeTextarea(
  el: HTMLTextAreaElement | null,
  maxRows?: number,
): void {
  if (!el || supportsFieldSizingContent) return

  el.style.height = 'auto'
  const scrollHeight = el.scrollHeight + 2
  el.style.height = `${
    maxRows ? Math.min(maxRows * BASE_ROW_HEIGHT, scrollHeight) : scrollHeight
  }px`
}

export function observeTextareaResize(
  el: HTMLTextAreaElement,
  maxRows?: number,
): (() => void) | null {
  if (supportsFieldSizingContent || typeof ResizeObserver === 'undefined')
    return null

  let lastWidth = el.offsetWidth
  const observer = new ResizeObserver(() => {
    const currentWidth = el.offsetWidth
    if (currentWidth !== lastWidth) {
      lastWidth = currentWidth
      autoResizeTextarea(el, maxRows)
    }
  })
  observer.observe(el)

  return () => observer.disconnect()
}
